import React from 'react';
import './Savings.scss';
import data from './data.json'; // Assuming data.json is used for the Savings component

function Savings() {
  return (    
    <>
    <div className="container">
      <div className='h'>
      <div className='rules-wrapper'>
        <div className="rules-content">
          Rules
        </div>
      </div>
      </div>
      <div className="app">
        <div className="header">
          <p>{data.account.type}</p>
          <h1>{data.account.currency}{data.account.balance.toFixed(2)}</h1>        
        </div>
        <div className="interest-info">
          <span>{data.links.interestDetails}</span>        
        </div>
        <div className="details">
          <div className="column">
            <p>Interest</p>
            <p>{data.interest.rate.toFixed(4)}%</p>
          </div>
          <div className="column">
            <p>History</p>
            <p>{data.links.transactionHistory}</p>
          </div>
        </div>
        <div className="buttons">
          <button disabled={!data.buttons.withdraw.enabled}>{data.buttons.withdraw.label}</button>
          <button disabled={!data.buttons.deposit.enabled}>{data.buttons.deposit.label}</button>
        </div>
      </div>
    </div>   <br />
    <p>Manou et Bineta</p>
    </> 
  );
}

export default Savings;
